<div class="card card-step card-step-hts" [ngClass]="{ 'is-desktop': isDesktop }">
  <div class="card-header">
    <ng-container *ngIf="isDesktop">
      <label class="hts-manufacturer-label">{{ "MANUFACTURER" | translate }} #{{ index + 1 }}</label>
      <p class="hts-manufacturer">{{ manufacturerFormGroup.value.mName }}</p>

      <button type="button" class="btn btn-link mf-edit" *ngIf="!disableMFEdit" (click)="editMF.emit()">
        <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
            fill="currentColor"
          />
        </svg>
      </button>

      <ng-container *ngIf="!!mAddress">
        <span class="hts-manufacturer-address-label">{{ "LABELS.ADDRESS" | translate }}</span>
        <address-details [address]="manufacturerFormGroup.value.mAddress"></address-details>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!isDesktop">
      <label>{{ "MANUFACTURER" | translate }}# {{ mName || mID }}</label>
    </ng-container>
  </div>
  <div class="card-body">
    <div class="container">
      <div class="row">
        <div class="col-12" [ngClass]="{ 'col-md-11': isDesktop }">
          <div class="form-row">
            <div class="col-6">
              <label [ngClass]="{ 'is-desktop': isDesktop }">{{ "LABELS.INTERNATIONAL_HTS_CODE" | translate }}</label>
            </div>
            <div class="col-6">
              <label [ngClass]="{ 'is-desktop': isDesktop }">{{ "FORM_LABEL.COUNTRY_OF_ORIGIN" | translate }}</label>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngFor="let htsFromGroup of controls; let idx = index">
        <div class="row">
          <div class="col-12" [ngClass]="{ 'col-md-11': isDesktop }">
            <div class="form-row">
              <div class="col-6">
                <app-isf-hts-control [fc]="htsFromGroup.get('number')"></app-isf-hts-control>
              </div>
              <div class="col-6">
                <auto-select
                  [bindLabel]="['code', 'description']"
                  [bindValue]="'id'"
                  [change]="searchCountry()"
                  [initializeItems]="initialCountries"
                  [errors]="countryErrors"
                  [fc]="htsFromGroup.get('countryOfOriginId')"
                  id="countryOfOriginCode"
                ></auto-select>
              </div>
            </div>
          </div>
          <div class="col-md-1 pl-0" *ngIf="isDesktop && idx !== controls.length - 1">
            <button type="button" class="btn btn-link hts-delete" (click)="removeName(idx)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
